import { useQuery } from "@tanstack/react-query";
import { IInvoice } from "../../../../create/interfaces/invoice.interfaces";
import { getInvoice, type GetInvoiceParams } from "../actions/getInvoice";

export type UseGetInvoiceParams = GetInvoiceParams;

// Supports invoiceUid (preferred) or jobEventsUids from magic-link tokens.
export const useGetInvoice = (params: UseGetInvoiceParams | string, tokenFromQuery?: any) => {
  // Normalize params to object format
  const normalizedParams: UseGetInvoiceParams = typeof params === "string" ? { invoiceUid: params } : params;

  const { invoiceUid, jobEventsUids } = normalizedParams;
  const jobEventsKey = jobEventsUids?.length ? [...jobEventsUids].sort().join(",") : undefined;

  const queryKey = ["invoice", invoiceUid ?? jobEventsKey ?? ""];

  const {
    data: invoice,
    isLoading,
    isError,
    error,
    isFetching,
    refetch,
  } = useQuery<IInvoice | null>({
    queryKey,
    queryFn: () => {
      return getInvoice(normalizedParams, tokenFromQuery);
    },
    enabled: !!(invoiceUid || (jobEventsUids?.length ?? 0) > 0),
    // Don't retry on 404 - it's a valid state (no invoice exists)
    retry: (failureCount, error: any) => {
      if (error?.response?.status === 404) {
        return false;
      }
      return failureCount < 3;
    },
  });

  // 404 is not an error - it just means no invoice exists
  const hasError = isError && error && (error as any)?.response?.status !== 404;

  return { data: invoice, isLoading, isError: hasError, refetch, isFetching };
};
